import React from "react";
import quizData from './quizData';   
import QnA from "./QnA";
import {nanoid} from "nanoid"

export default function Quiz(props){
  /*Quiz Component*/
    const [quiz,setQuiz] = React.useState([{
      id:"",
      question:"",
      correct_answer:"",
      incorrect_answer:[],
      allAnswers:[],
      check_correct:false
    }])

    const [points,setPoints] = React.useState(0);
    const [check,setCheck] = React.useState(false);

    
    // React.useEffect(()=>{
    //     fetch("https://opentdb.com/api.php?amount=5&category=11&difficulty=easy&type=multiple")
    //     .then(res=>res.json())
    //     .then(data=>(setAllQuiz(data.results)))
      
    //   },[])
    
    
    
    // const [allQuiz, setAllQuiz] = React.useState(quizData)
    
    
    
    //     console.log(allQuiz)
    //      const quizElements = allQuiz.map(quiz =>{
      //         const answers = [];
      //         answers.push(quiz.correct_answer)
    //         const incorrect = quiz.incorrect_answers.map(ic=>(answers.push(ic)))
    //         console.log(answers)
    
    //        return(
      //         <QnA 
      //         question={quiz.question}
      //         answers={answers}
      //         correct={quiz.correct_answer}
      //         incorrect={quiz.incorrect_answers}
      //         />
      //        )
      //      })
      React.useEffect(() => {
        fetch("https://opentdb.com/api.php?amount=5&category=11&difficulty=easy&type=multiple")
          .then(res=>res.json())
          .then(data=>(newQuiz(data.results)))
     }, [])
    
     function newQuiz(data){
       if(check===false){
         data.map(quizData=>{
           
          function shuffle(answers){
             for(let i=answers.length-1;i>0;i--){
               const j = Math.floor(Math.random()*(i+1))
               const temp = answers[i]
               answers[i] = answers[j]
               answers[j] = temp
             }
             return answers;
           }
          
           const incorrect_ans = quizData.incorrect_answers
           console.log(incorrect_ans)
           const correct_ans = [{
             text:quizData.correct_answer,
             correct:true,
             clicked:false,
             id:nanoid()
            }]

          const all_incorrect = incorrect_ans.map(answer=>({
            text:answer,
            correct:false,
            clicked:false,
            id:nanoid()
          }))
          console.log(all_incorrect)
          console.log(correct_ans)
          const allAnswers = correct_ans.concat(all_incorrect)
          
          const shuffled_ans = shuffle(allAnswers)
          console.log(allAnswers)

          setQuiz(prevQuiz=>[
            ...prevQuiz,
            {
              id:nanoid(),
              question:quizData.question,
              correct_answer:quizData.correct_answer,
              incorrect_answers:quizData.incorrect_answers,
              allAnswers:shuffled_ans ,
              check_correct:false
            }
          ])

         })
       }
     }

     function countPoints(correct,questionId){
       setQuiz(prev=>prev.map(quest=>{
         if(quest.id==questionId){
           return {...quest, check_correct: correct}
         }else{
           return{...quest}
         }
       }))
     }

     const quizElements = quiz.map(quiz => {
       return(
         <QnA
            key={quiz.id}
            question={quiz.question}
            correct_answer={quiz.correct_answer}
            allAnswers={quiz.allAnswers}
            check={check}
           countPoints={countPoints}
            id={quiz.id}
         />
       )
     })
      
     function checkAnswers(){
       setCheck(true)
       setPoints(quiz.filter(question=>question.check_correct===true).length)
     }
      
      
      return (
        <div className="">
         <div className='quiz-div'> 
          {quizElements}
          <div className="checking-div">
          {
          check 
            ? 
          <div className="points">You scored {points}/5</div>
            : 
          ""
          }
          {
          check 
            ? 
          <button className="start-btn" onClick={props.startQuiz}>Play Again</button>
            :
          <button className="start-btn checkans" onClick={checkAnswers} >Check Answers</button>  
          }
          </div>
         </div> 
        </div>
      );
}
// import React from "react"
// import QnA from "./QnA"
// import {nanoid} from "nanoid"



// export default function Quiz(props){
     
//      /** Set quiz **/
//     const [quiz,setQuiz] = React.useState([{
//          id:"",
//          question: "", 
//          correct_answer: "", 
//          incorrect_answers: [],
//          all_answers: [],
//          answerCorrect: false
//          }])
//     const [checking, setChecking] = React.useState(false)
//     const [score,setScore] = React.useState(0)
    

//     React.useEffect(() => {
//         fetch("https://opentdb.com/api.php?amount=5")
//             .then(res => res.json())
//             .then(data => (makeNewQuiz(data.results)))
      
//      }, [])
   

    
//     function makeNewQuiz(data){
//         if (checking==false){
//             data.map(quizData=>{
            
//                 function shuffleArray(array){
//                     for (let i = array.length - 1; i > 0; i--) {
//                         const j = Math.floor(Math.random() * (i + 1));
//                         const temp = array[i];
//                         array[i] = array[j];
//                         array[j] = temp;
//                 }
//                 return array;
//                 }
//                 const iAnswers = quizData.incorrect_answers
//                 const cAnswer = [{text:quizData.correct_answer, correct:true, clicked:false, id:nanoid()}]
//                 const iObjectArray = iAnswers.map(answer =>( {text:answer,correct:false, clicked:false, id:nanoid()}))
//                 const allAnswers = cAnswer.concat(iObjectArray)
//                 const shuffledAnswers = shuffleArray(allAnswers)
//                 setQuiz(prevQuiz=> [...prevQuiz,{
//                         id:nanoid(),
//                         question: quizData.question, 
//                         correct_answer: quizData.correct_answer, 
//                         incorrect_answers: quizData.incorrect_answers,
//                         all_answers: shuffledAnswers,
//                         answerCorrect: false
//                         }])
            
               
        
//         })
//         }
//     }
//     function countScore(correct,questionId){

//         setQuiz(prevQuiz=> prevQuiz.map(quest=>{
//             if(quest.id==questionId){
//                 return {...quest, answerCorrect: correct}
              
//             }else{
//                 return {...quest}
                
//             }
//         })
//       )
//     }
//    console.log(quiz)
//     const quizElements = quiz.map(quest =>{
//                return (
//                 <QnA
//                     key={quest.id}
//                     question={quest.question} 
//                     correctAnswer={quest.correct_answer} 
//                     allAnswers={quest.all_answers}
//                     checking={checking}
//                     countScore={countScore}
//                     id={quest.id}
//                 />
//             )}
//    )

//    function checkAnswers(){
//         setChecking(true)
//         setScore(quiz.filter(question=> question.answerCorrect===true).length)
       
//     }
    
  
//     return(
       
//             <div className="quiz">
//             {quizElements}
//             {checking?<div className="score">You scored {score}/5</div>:""}
//              {checking?<button className="check-btn" onClick={props.startQuiz}>Play again
//              </button>:<button className="check-btn" onClick={checkAnswers}>Check Answers</button>}
//              </div>
     
//     )
// }